module.exports = __webpack_public_path__ + "img/25B6.978b73f6.svg";